import React from 'react';
import PropTypes from 'prop-types';
import { Popconfirm } from 'antd';
import { Form } from 'react-final-form';

import {
    accountTypes,
    composeValidators,
    i18,
    required,
    requiredEmail,
    requiredPhone
} from '../../../utilities';
import { ButtonGroup, ButtonWrapper, FormField, formFieldType, Translate } from '../../../components';

export const InternalClientForm = (props) => {
    return (
        <Form
            onSubmit={props.onClientUpdate}
            initialValues={{
                ...props.client
            }}
            render={({ handleSubmit, values, form }) => (
                <form
                    onSubmit={handleSubmit}
                    autoComplete='off'
                >
                    {values.type === accountTypes.JURIDICAL && (
                        <>
                            <FormField
                                inline
                                title={i18.InternalClientsCreateForm.Labels.CompanyName}
                                name='companyName'
                                component={formFieldType.input}
                                validate={required}
                                maxLength={50}
                                disabled={props.submitting}
                            />
                            <FormField
                                inline
                                title={i18.InternalClientsCreateForm.Labels.CompanyCode}
                                name='companyCode'
                                component={formFieldType.input}
                                validate={required}
                                maxLength={30}
                                disabled={props.submitting}
                            />
                            <FormField
                                inline
                                title={i18.InternalClientsCreateForm.Labels.VatPayerCode}
                                name='vatPayerCode'
                                component={formFieldType.input}
                                validate={required}
                                maxLength={30}
                                disabled={props.submitting}
                            />
                        </>
                    )}
                    {values.type === accountTypes.PHYSICAL && (
                        <>
                            <FormField
                                inline
                                title={i18.InternalClientsCreateForm.Labels.FirstName}
                                name='firstName'
                                component={formFieldType.input}
                                validate={required}
                                maxLength={25}
                                disabled={props.submitting}
                            />
                            <FormField
                                inline
                                title={i18.InternalClientsCreateForm.Labels.LastName}
                                name='lastName'
                                component={formFieldType.input}
                                validate={required}
                                maxLength={25}
                                disabled={props.submitting}
                            />
                        </>
                    )}
                    <FormField
                        inline
                        title={i18.InternalClientsCreateForm.Labels.Address}
                        name='address'
                        component={formFieldType.input}
                        validate={required}
                        maxLength={100}
                        disabled={props.submitting}
                    />
                    <FormField
                        inline
                        title={i18.InternalClientsCreateForm.Labels.Phone}
                        name="phone"
                        component={formFieldType.phone}
                        disabled={props.submitting}
                        validate={requiredPhone({ nullable: true })}
                    />
                    <FormField
                        inline
                        title={i18.InternalClientsCreateForm.Labels.Email}
                        name='email'
                        component={formFieldType.input}
                        validate={requiredEmail}
                        maxLength={256}
                        disabled={props.submitting}
                    />
                    <FormField
                        inline
                        title={i18.InternalClientsCreateForm.Labels.InvoiceEmail}
                        name='invoiceEmail'
                        component={formFieldType.input}
                        validate={composeValidators(required, requiredEmail)}
                        maxLength={256}
                        disabled={props.submitting}
                    />
                    <div className='text-right'>
                        <ButtonGroup>
                            <ButtonWrapper
                                type='text'
                                disabled={props.submitting}
                                onClick={() => props.onCancel()}
                            >
                                <Translate value={i18.InternalClientsCreateForm.Buttons.Cancel} />
                            </ButtonWrapper>
                            <Popconfirm
                                key='create'
                                placement='left'
                                onConfirm={() => form.submit()}
                                title={<Translate value={i18.InternalClientsCreateForm.Labels.ConfirmationTitle} />}
                                okText={<Translate value={i18.InternalClientsCreateForm.Labels.ConfirmationOkText} />}
                                cancelText={<Translate value={i18.InternalClientsCreateForm.Labels.ConfirmationCancelText} />}
                            >
                                <ButtonWrapper
                                    type='primary'
                                    htmlType='submit'
                                    loading={props.submitting}
                                >
                                    <Translate value={i18.InternalClientsCreateForm.Buttons.Submit} />
                                </ButtonWrapper>
                            </Popconfirm>
                        </ButtonGroup>
                    </div>
                </form>
            )}
        />
    );
};

InternalClientForm.propTypes = {
    client: PropTypes.object,
    onClientUpdate: PropTypes.func,
    onCancel: PropTypes.func,
    submitting: PropTypes.bool
};
